export const planPreviewTopBar_style = {};
